/** TimeZones for the web: the browser's IANA list (`Intl.supportedValuesOf`) and offsets from `Intl.DateTimeFormat`. */
import type { TimeZones } from "@bundle/core";

const FALLBACK = ["UTC", "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles", "America/Sao_Paulo", "Europe/London", "Europe/Paris", "Europe/Berlin", "Asia/Kolkata", "Asia/Tokyo", "Australia/Sydney"];

let list: string[] | undefined;
const formatters = new Map<string, Intl.DateTimeFormat | null>();

function formatter(zone: string): Intl.DateTimeFormat | null {
  let f = formatters.get(zone);
  if (f === undefined) {
    try {
      f = new Intl.DateTimeFormat("en-US", { timeZone: zone, hourCycle: "h23", year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
    } catch {
      f = null;
    }
    formatters.set(zone, f);
  }
  return f;
}

export const browserTimeZones: TimeZones = {
  list() {
    if (list === undefined) {
      const intl = Intl as unknown as { supportedValuesOf?: (key: "timeZone") => string[] };
      const zones = intl.supportedValuesOf?.("timeZone") ?? FALLBACK;
      list = [...new Set([...zones, "UTC"])].toSorted();
    }
    return list;
  },
  device() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? "UTC";
  },
  offsetMinutes(zone, at) {
    const f = formatter(zone);
    if (f === null) return undefined;
    const p: Record<string, number> = {};
    for (const part of f.formatToParts(at)) if (part.type !== "literal") p[part.type] = Number(part.value);
    const asUtc = Date.UTC(p.year!, p.month! - 1, p.day!, p.hour!, p.minute!);
    return Math.round((asUtc - Math.floor(at / 60_000) * 60_000) / 60_000);
  },
};
